import { cn } from "@/lib/utils";

interface BlogImageProps {
  src: string;
  alt: string;
  className?: string;
  priority?: boolean;
}

const BlogImage = ({ src, alt, className, priority = false }: BlogImageProps) => {
  return (
    <figure className={cn("w-full overflow-hidden rounded-xl", className)}>
      <img
        src={src}
        alt={alt}
        loading={priority ? "eager" : "lazy"}
        decoding="async"
        className="w-full h-full object-cover transition-transform duration-300 hover:scale-105"
        sizes="(max-width: 640px) 100vw, (max-width: 1024px) 80vw, 800px"
      />
      <figcaption className="sr-only">{alt}</figcaption>
    </figure>
  );
};

export default BlogImage;
